export default "__VITE_ASSET__a8939dd8__"